import React from 'react';
import './Glossary.css';
import Word from './Glossary.json';


export default class Glossary extends React.Component {
    constructor () {
      super();
      this.state = {
        activeCategory: "A-G"
      }
    }
  
    setCategory (category) {
      this.setState({ activeCategory: category });
    }
  
    render () {
      return (
        <div>
        <div className="buttons">
        <input className="button" type="radio" id="A-G" name="btn" onChange={() => {this.setCategory('A-G')}}/>
        <label htmlFor="A-G">A-G</label>
        <input className="button" type="radio" id="H-N"  name="btn" onChange={() => { this.setCategory('H-N') }} />
        <label htmlFor="H-N">H-N</label>
        <input className="button" type="radio" id="O-T"  name="btn" onChange={() => { this.setCategory('O-T') }} />
        <label htmlFor="O-T">O-T</label>
      </div>


      
        <div className="glossarycontent">
            {Word.filter((word) => word.tag === this.state.activeCategory).map((Word,index) => {
            return <div  class="glossary"><p class="word">{Word.word}</p> <p class="wordtext">{Word.definition}</p>
            </div>
        })}
        </div>
        </div>
  
  
    )
    }
  }